import { NextRouter } from "next/router";
import { decamelizeKeys } from "humps";
import { stringify } from "qs";
import { removeEmpty } from "./ObjectUtil";

export function getAbsoluteUrl(req, setLocalhost = null) {
  let protocol = "https:";
  let host = req
    ? req.headers["x-forwarded-host"] || req.headers["host"]
    : window.location.host;
  if (host.indexOf("localhost") > -1) {
    if (setLocalhost) host = setLocalhost;
    protocol = "http:";
  }
  return {
    protocol: protocol,
    host: host,
    origin: protocol + "//" + host,
  };
}

export function pushUrl(param: any, router: NextRouter): void {
  // console.log(router);
  const path = getBasePath(router.asPath);
  const queryParam = decamelizeKeys(removeEmpty(param));
  let newUrl = `${path}?${stringify(queryParam, {
    arrayFormat: "indices",
  })}`;
  if (location.hash) {
    newUrl += location.hash; // lineなどがaccessTokenなどをくっつけてるため
  }
  // shallow: trueにしないと再度サーバーサイドの処理が動作してしまうため注意
  router.push(newUrl, null, { shallow: true });
}

export function getBasePath(url: string) {
  const pathWithoutHash = url.split("#")[0];
  return pathWithoutHash.split("?")[0];
}
